import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportDriverActivitiesCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'
import { ExportUnknownDriverLocations } from '../components/ExportsSettings/ExportUnknownDriverLocations'
import { useModuleConfig } from '@/utils/hooks'
import { Module, ModuleOptionsValue } from '../../consts'
import { ExportActivityExceptionReportCard } from '../components/ExportsSettings/export-activity-exception-report-card'
import {
  EXPORT_OUT_OF_SCOPE_DRIVING,
  EXPORT_START_STOP_COUNTRY_REGISTRATIONS,
} from '@/modules/exports/mutations'

export function ExportActivities() {
  const translations = useTranslate({
    activities: 'common.activities',
    outDrivingReport: 'activities.out-driving-report',
    startStopCountryReport: 'activities.start-stop-country-report',
  })

  const { getModuleOption } = useModuleConfig(Module.ACTIVITIES)

  const moduleOptionActive = getModuleOption(
    ModuleOptionsValue.ACTIVITIES_PROCESS_TACHO_FILES
  )

  return (
    <ExportSection header={translations.activities}>
      <ExportDriverActivitiesCard />
      {moduleOptionActive && <ExportUnknownDriverLocations />}
      {moduleOptionActive && (
        <ExportActivityExceptionReportCard
          header={translations.outDrivingReport}
          mutation={EXPORT_OUT_OF_SCOPE_DRIVING}
          resultKey="exportOutOfScopeDriving"
        />
      )}
      {moduleOptionActive && (
        <ExportActivityExceptionReportCard
          header={translations.startStopCountryReport}
          mutation={EXPORT_START_STOP_COUNTRY_REGISTRATIONS}
          resultKey="exportStartStopCountryRegistrations"
        />
      )}
    </ExportSection>
  )
}
